// Services
import { getWalletBalance, getWalletTransactions } from '@/_services/rayzorpay-service';

// State Management
import { create } from 'zustand';



interface Transaction {
  id: number;
  amount: number;
  description: string;
  transaction_type: "credit" | "debit";
  balance_after: number;
  created_at: string;
}

interface WalletState {
  balance: number | null;
  loadingBalance: boolean;
  balanceError: string | null;
  transactions: Transaction[];
  loadingTransactions: boolean;
  transactionsError: string | null;
  fetchBalance: () => void;
  fetchTransactions: (params?: any) => void;
}

export const useWalletStore = create<WalletState>((set) => ({
  balance: null,
  loadingBalance: false,
  balanceError: null,

  transactions: [],
  loadingTransactions: false,
  transactionsError: null,

  fetchBalance: async () => {
    set({ loadingBalance: true, balanceError: null });
    try {
      const balance = await getWalletBalance();
      set({ balance, loadingBalance: false });
    } catch (error) {
      set({ balanceError: 'Failed to fetch wallet balance', loadingBalance: false });
    }
  },

  fetchTransactions: async (params = {}) => {
    set({ loadingTransactions: true, transactionsError: null });
    try {
      const transactions = await getWalletTransactions(params);
      set({ transactions, loadingTransactions: false });
    } catch (error) {
      set({ transactionsError: 'Failed to fetch transactions', loadingTransactions: false });
    }
  },
}));
